import type { CheckItem, Section } from '../types';
import { sectionItemSort } from './sectionItemSort';

/** Insert moved item respecting the destination section's sort order. */
export function insertItemIntoSection(section: Section, item: CheckItem): void {
  if (sectionItemSort(section) === 'oldest') {
    section.items.push(item);
  } else {
    section.items.unshift(item);
  }
}

/** Append items to the end of the section checklist (ignores item sort). */
export function appendItemsToSectionBottom(section: Section, items: CheckItem[]): void {
  for (const item of items) {
    section.items.push(item);
  }
}
